import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-user-menu',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss'
})
export class UserMenuComponent implements OnInit{
  activeRoute: string = '';
  constructor(private router: Router){}
  
  menuItems = [
    { label: 'Account', link: '/user-profile', active: false },
    { label: 'Settings', link: '/settings', active: false },
    { label: 'Support', link: '/support', active: false }
  ];

  ngOnInit(): void {
    this.activeRoute =  this.router.url;
      this.menuItems.forEach((item => {
        if(item.link === this.activeRoute) {
          item.active = true;
        }
      }));
  }
}
